/* global swal  angular*/
import { merge } from 'lodash';
import './style.less';

export default function($log, $uibModalInstance, ApiClass, external) {
  'ngInject';
  const vm = this;

  vm.external = external;

  vm.externalHasError = external ? !!external.error : false;

  vm.close = () => $uibModalInstance.dismiss('close');

  vm.getCnfPollLength = () => (external.data ? Object.keys(external.data.polls || {}).length : 0);

  vm.patchExternal = (external, updates) => {
    const { type, parentId: id } = vm.external;

    ApiClass.eventsIdTypeTypeIdPatch(
      { id, type_id: external.uuid, type: 'eventExternal' },
      { ...updates, type },
      {
        queryParams: { manage: true }
      }
    )
      .then(() => {
        merge(external, updates);
        vm.close();
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/modals/manageEventExternal/controller.js